import VSnackbar from './VSnackbar'

export default {
  VSnackbar
}



// WEBPACK FOOTER //
// ./src/components/snackbars/index.js